import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import WistiaVideo from 'components/WistiaVideo';

const CompanyHeroSection = ({
  backgroundImg,
  backgroundColor,
  title,
  titleColor,
  description,
  descriptionColor,
  video,
  ...otherProps
}) => {
  return (
    <SectionCompanyHero
      backgroundColor={backgroundColor}
      backgroundImg={backgroundImg}
      titleColor={titleColor}
      descriptionColor={descriptionColor}
      {...otherProps}
    >
      <div className="section-company-hero--container">
        <h2 className="section-company-hero--title">{title}</h2>
        <p className="section-company-hero--description">{description}</p>
        <WistiaVideo
          className="section-company-hero--video-button"
          url={video.wistiaVideo}
          showPlayButtonOnly
        />
      </div>
    </SectionCompanyHero>
  );
};

CompanyHeroSection.propTypes = {
  title: PropTypes.string,
  titleColor: PropTypes.string,
  description: PropTypes.string,
  descriptionColor: PropTypes.string,
  backgroundImg: PropTypes.string,
  backgroundColor: PropTypes.string,
  buttonTitle: PropTypes.string,
  buttonType: PropTypes.string,
  buttonLinkTo: PropTypes.string,
};

const SectionCompanyHero = styled.div`
  padding: 0 28px;
  background: ${props =>
    props.backgroundImg != null ? 'url(' + props.backgroundImg + ')' : props.backgroundColor};
  background-repeat: no-repeat;
  background-size: cover;

  .section-company-hero--container {
    padding: 389px 28px 230px;
    margin: 0 auto;
    text-align: center;
    overflow: hidden;

    .section-company-hero--title {
      font-weight: 900;
      font-size: 61px;
      line-height: 110%;
      letter-spacing: -0.05em;
      color: ${props => props.titleColor};
      max-width: 990px;
      margin: 0 auto;
    }

    .section-company-hero--description {
      font-weight: 500;
      font-size: 20px;
      line-height: 150%;
      color: ${props => props.descriptionColor};
      max-width: 788px;
      margin: 40px auto;
    }

    .section-company-hero--video-button {
      margin-left: auto;
      margin-right: auto;

      & > button {
        margin: -50px -50px !important;
      }

      @media (max-width: 576px) {
        position: relative;
        height: auto;
        margin-top: 50px;
        button {
          right: 0;
        }
      }
      button {
        margin: 0 auto;
      }
    }
  }

  @media (max-width: 991px) {
  }

  @media (max-width: 768px) {
    .section-company-hero--container {
      padding: 169px 0 89px;

      .section-company-hero--title {
        font-size: 32px;
        letter-spacing: -0.03em;
        max-width: 590px;
      }

      .section-company-hero--description {
        font-size: 17px;
        margin-top: 16px;
        max-width: 468px;
      }
    }
  }

  @media (max-width: 576px) {
    padding: 0 20px;

    .wistia-video--play-button {
      top: -30px !important;
    }
  }
`;

export default CompanyHeroSection;
